import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '@/store/state';
import { mutations } from '../mutations';
import { AdminState } from '../state';

const { commit } = getStoreAccessors<AdminState, State>('');

export const commitSetUser = commit(mutations.setUser);
export const commitSetUsers = commit(mutations.setUsers);
export const commitSetService = commit(mutations.setService);
export const commitSetServices = commit(mutations.setServices);
export const commitSetSender = commit(mutations.setSender);
export const commitSetSenders = commit(mutations.setSenders);
export const commitSetTemplate = commit(mutations.setTemplate);
export const commitSetTemplates = commit(mutations.setTemplates);
export const commitSetProxyError = commit(mutations.setProxyError);
export const commitSetProxyErrors = commit(mutations.setProxyErrors);
export const commitSetPriorities = commit(mutations.setPriorities);
export const commitSetPriority = commit(mutations.setPriority);
export const commitSetMNOs = commit(mutations.setMNOs);
export const commitSetMNO = commit(mutations.setMNO);
export const commitSetMNOMasks = commit(mutations.setMNOMasks);
export const commitSetMNOSenders = commit(mutations.setMNOSenders);
export const commitSetTemplateProxyResponse = commit(mutations.setTemplateProxyResponse);
export const commitSetCheckMNOMaskResponse = commit(mutations.setCheckMNOMaskResponse);
export const commitSetTags = commit(mutations.setTags);
export const commitSetServiceBanPolicy = commit(mutations.setServiceBanPolicy);
export const commitSetServiceBanPolicies = commit(mutations.setServiceBanPolicies);
